import { Controller } from '@hotwired/stimulus'

// Native HTML5 drag-and-drop sortable controller
// Usage: data-controller="admin--sortable"
//        data-admin--sortable-url-value="/admin/providers/reorder"
//        data-admin--sortable-param-value="provider_ids"
export default class extends Controller {
  static values = {
    url: String,
    param: { type: String, default: 'ids' }
  }

  static targets = ['item']

  connect() {
    this.draggedItem = null
    this.setupDragListeners()
  }

  setupDragListeners() {
    this.itemTargets.forEach((item) => {
      item.setAttribute('draggable', 'true')
      item.addEventListener('dragstart', this.handleDragStart.bind(this))
      item.addEventListener('dragend', this.handleDragEnd.bind(this))
      item.addEventListener('dragover', this.handleDragOver.bind(this))
      item.addEventListener('dragenter', this.handleDragEnter.bind(this))
      item.addEventListener('dragleave', this.handleDragLeave.bind(this))
      item.addEventListener('drop', this.handleDrop.bind(this))
    })
  }

  handleDragStart(event) {
    this.draggedItem = event.currentTarget
    event.currentTarget.classList.add('opacity-50', 'bg-slate-100')
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', event.currentTarget.dataset.id)
  }

  handleDragEnd(event) {
    event.currentTarget.classList.remove('opacity-50', 'bg-slate-100')
    this.itemTargets.forEach((item) => {
      item.classList.remove('border-t-2', 'border-blue-500')
    })
    this.draggedItem = null
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }

  handleDragEnter(event) {
    event.preventDefault()
    const target = event.currentTarget
    if (target !== this.draggedItem) {
      target.classList.add('border-t-2', 'border-blue-500')
    }
  }

  handleDragLeave(event) {
    event.currentTarget.classList.remove('border-t-2', 'border-blue-500')
  }

  handleDrop(event) {
    event.preventDefault()
    const target = event.currentTarget
    target.classList.remove('border-t-2', 'border-blue-500')

    if (this.draggedItem && target !== this.draggedItem) {
      const items = Array.from(this.itemTargets)
      const draggedIndex = items.indexOf(this.draggedItem)
      const targetIndex = items.indexOf(target)

      if (draggedIndex < targetIndex) {
        target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
      } else {
        target.parentNode.insertBefore(this.draggedItem, target)
      }

      this.saveOrder()
    }
  }

  async saveOrder() {
    const ids = this.itemTargets.map((item) => item.dataset.id)

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ [this.paramValue]: ids })
      })

      if (!response.ok) {
        console.error('Failed to save order')
      }
    } catch (error) {
      console.error('Error saving order:', error)
    }
  }
}
